document.addEventListener('DOMContentLoaded', function () {
  const ctaSlider = document.querySelector('.hf-cta-image-slider .slider');
  
  if (ctaSlider) {
    const slides = ctaSlider.querySelectorAll('.slide');
    const totalSlides = slides.length;
    let currentIndex = 0;

    function showSlide(index) {
      ctaSlider.style.transform = `translateX(-${index * 100}%)`;
    }

    if (totalSlides > 1) {
      setInterval(() => {
        currentIndex = (currentIndex + 1) % totalSlides;
        showSlide(currentIndex);
      }, 5000);
    }
  }
});
